import React, { useContext } from "react";
import { Divider } from "antd";
import { useTranslation } from "react-i18next";
import ProductUnits from "./ProductUnits";
import ProductCategories from "./ProductCategories";
import CurrencyRate from "./CurrencyRate";
import DatabaseBackup from "./DatabaseBackup";
import AudioChange from "./AudioChange";
import Modes from "./Modes";
import hasPermission from "../../../../utils/hasPermission";
import { AuthContext } from "../../../../contexts/auth/AuthContext";
import KpiSettings from "./KpiSettings";

export default function SiteSettingsTab() {
  const { t } = useTranslation();
  const { authState } = useContext(AuthContext);
  return (
    <>
      <Divider orientation="left">Режимы</Divider>
      <Modes />
      {hasPermission(authState.user) ? (
        <>
          <Divider orientation="left">{t("productUnits")}</Divider>
          <ProductUnits />
          <Divider orientation="left">{t("categories")}</Divider>
          <ProductCategories />
          {/* <Divider orientation="left">{t("currencyRate")}</Divider>
          <CurrencyRate /> */}
          {/* <Divider orientation="left">{t("changingOrderAudio")}</Divider>
          <AudioChange /> */}
          {/* <Divider orientation="left">{t("database")}</Divider>
          <DatabaseBackup /> */}
          <Divider orientation="left">KPI Настройка</Divider>
          <KpiSettings />
        </>
      ) : (
        <></>
      )}
    </>
  );
}
